import { captureEvent } from '../../utils/posthogClient';
import { PH_CTA, PH_DIRECT, PH_PLACEMENT } from '../../utils/posthogEvents';
import parser from 'html-react-parser';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { useDocContext } from '../../context/DocContext';
import { Container, Row, Col } from 'react-bootstrap';
import {
  ArrowBlue,
  ArrowRightShort,
  ArrowWhiteShort,
  BlueCheckMark,
} from '../../assets/icons';
import { ArrowRightLong } from '../../assets/icons';
import { TrustBoxWide } from '../trustBox';
import {
  trustPilotNewer,
  stdStep1,
  stdStep2,
  stdStep3,
  medicineBottle,
  weightLossStep1,
  weightLossStep2,
  howStep3,
  weightLoss,
} from '../../assets/images';
import {
  weightLossOral,
  weightLossInjection,
} from '../../assets/imageLibrary2';
import Ribbon from '../ribbon';
import Steps from '../steps';
import HeroHeading from './HeroHeading';
const Hero = ({
  breadcrumbs = null,
  category,
  title,
  path,
  subText,
  avatar,
  hero,
  showNav,
  service,
  price,
  sections,
  symptoms,
  image2,
  how_it_works,
  right_for_you = null,
  objectID,
}) => {
  const hasRightForYouContent =
    right_for_you != null &&
    !!(
      right_for_you.heading ||
      right_for_you.intro ||
      right_for_you.items ||
      right_for_you.footer_note
    );
  const [newSections, setNewSections] = useState(sections);
  const { isWeightlossDiscountEligible } = useDocContext();
  const { hasSubscription } = useDocContext();
  const isWeightloss = category?.objectId == 'iezHwCrWYY';

  // This hero serves the condition detail pages, which includes the sexual
  // health conditions. Only the homepage CTA was reporting, so none of these
  // clicks showed up at all. The placement stays at category level, never the
  // condition itself, which is the same line the URL grouping draws.
  const ctaPlacement =
    category?.objectId === 'YAhR6Nfm4U'
      ? PH_PLACEMENT.SEXUAL_HEALTH_PAGE
      : PH_PLACEMENT.CONDITION_PAGE;
  const reportCta = () =>
    captureEvent(PH_DIRECT.CLICK, {
      cta: PH_CTA.START_TREATMENT,
      placement: ctaPlacement,
    });
  const [activeSection, setActiveSection] = useState(0);

  const symptomsSection = Array.isArray(sections)
    ? sections.find(
        (section) =>
          typeof section.heading === 'string' &&
          section.heading.toLowerCase().includes('symptoms')
      )
    : null;

  const symptomsList = extractListItems(symptomsSection?.content);

  const parseHTML = (value) => {
    if (typeof value !== 'string') return null;
    return parser(value);
  };
  const selectedMed = weightLossMeds.find((med) => med.id === objectID);
  return (
    <>
      <section className='tw-w-full tw-py-8 lg:tw-pt-32 lg:tw-pb-16 tw-bg-[#FFF]'>
        <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem]'>
          <Container fluid className='px-0'>
            <Row className=''>
              <Col xs={12} lg={6}>
                <div className='tw-w-full tw-flex tw-flex-col tw-gap-y-4 lg:tw-gap-y-6'>
                  {breadcrumbs}
                  <HeroHeading title={title} isWeightloss={isWeightloss} />

                  <p className='tw-m-0 tw-text-[#5F5F5F]'>
                    {parseHTML(subText)}
                  </p>

                  <ul className='tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-y-4'>
                    <li className='tw-flex tw-items-center tw-gap-x-2 tw-text-[#195D9D] lg:tw-text-xl'>
                      <BlueCheckMark />
                      Get your medication refill fast
                    </li>
                    <li className='tw-flex tw-items-center tw-gap-x-2 tw-text-[#195D9D] lg:tw-text-xl'>
                      <BlueCheckMark />
                      Professional care available 24/7
                    </li>
                    <li className='tw-flex tw-items-center tw-gap-x-2 tw-text-[#195D9D] lg:tw-text-xl'>
                      <BlueCheckMark />
                      Prescription within 45 minutes
                    </li>
                  </ul>
                </div>
                <div className='tw-flex tw-flex-col tw-gap-y-4 tw-w-full tw-mt-6'>
                  <div className='tw-flex tw-flex-col tw-gap-y-2 lg:tw-w-fit XL:tw-flex-row lg:tw-items-center tw-gap-x-4 tw-w-full'>
                    <button
                      //onClick={() => getTreated('EPzuICJy88')}
                      className='refill-cta tw-border-none tw-w-full lg:tw-w-[403px]'
                    >
                      <Link href={`${path}`}>
                        <div
                          onClick={reportCta}
                          className='tw-w-full tw-bg-black tw-text-white tw-flex tw-items-center tw-gap-x-2 tw-justify-center tw-px-4 tw-h-14 lg:tw-h-[62px] tw-rounded-full tw-font-medium tw-text-xl'
                        >
                          {isWeightloss
                            ? 'Start medical assessment'
                            : 'Get treatment online'}
                          <ArrowRightShort />
                        </div>
                      </Link>
                    </button>

                    <div className='tw-flex tw-items-center tw-justify-center tw-gap-x-1  '>
                      <p className='tw-text-sm tw-m-0 tw-text-doc_gray'>
                        {isWeightloss ? 'First order' : 'at just'}
                      </p>
                      <p className='tw-m-0 tw-font-semibold gradientText'>
                        {isWeightloss ? '15% off' : `$${price.toFixed(2)}`}
                      </p>
                    </div>
                  </div>

                  <p className='tw-m-0 xl:tw-ml-10 tw-text-[#5F5F5F] tw-text-sm tw-text-center lg:tw-text-left lg:tw-text-sm'>
                    {isWeightloss ? '10' : '5'}-minute assessment • No office
                    visit required
                  </p>
                  {category?.objectId == 'YAhR6Nfm4U' && (
                    <p className='STDWarning tw-m-0 tw-text-center xl:tw-text-left xl:tw-ml-10'>
                      Partner treatment at 50% off.
                    </p>
                  )}
                </div>
              </Col>
              <Col xs={12} lg={6} className='tw-relative tw-mt-6 lg:tw-mt-0'>
                <div className='position-relative tw-h-[343px] lg:tw-min-h-[700px]'>
                  <div className='tw-absolute tw-z-10 tw-bottom-4 tw-right-4 tw-bg-white tw-py-3 tw-px-5 tw-rounded-lg'>
                    <div className='tw-flex tw-flex-col tw-gap-y-3'>
                      {' '}
                      <div className='tw-flex tw-flex-col tw-items-center'>
                        <span className='tw-font-medium tw-text-lg'>
                          Excellent
                        </span>
                        <span className='tw-text-[#5F5F5F] tw-text-sm'>
                          4.2 out of 5
                        </span>
                      </div>
                      <hr className='tw-m-0' />
                      <div className=''>
                        <Image
                          src={trustPilotNewer}
                          width={110}
                          height={24}
                          alt='TrustPilot logo'
                        />
                      </div>
                    </div>
                  </div>
                  <Image
                    src={hero}
                    alt='hero-image'
                    layout='fill'
                    className='tw-rounded-2xl tw-object-cover'
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>{' '}
      <Ribbon />
      <Steps
        placement={ctaPlacement}
        buttonText={'Get treatment online'}
        steps={isWeightloss ? weightLossSteps : steps}
        path={path}
        showTicker={false}
        subText={
          isWeightloss
            ? 'Medical weight loss — personalized, guided, and delivered to you.'
            : 'Get your prescription reviewed and sent — without the wait. Most requests completed in within hours.'
        }
        superText={'Simple 3-Step Process'}
        how_it_works={isWeightloss ? null : how_it_works}
      />
      {/*If not weight loss medication */}
      {!weightLossMeds.some((med) => med.id === objectID) && (
        <section className='tw-w-full tw-py-8 lg:tw-py-16'>
          <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem]'>
            <Container fluid className='px-0 '>
              <Row>
                <Col lg={5}>
                  <div className='tw-w-full tw-flex tw-flex-col tw-gap-y-8 '>
                    <h2 className='tw-m-0 tw-text-2xl lg:tw-text-4xl XL:tw-text-5xl tw-font-semibold !tw-leading-[3.5rem]'>
                      {hasRightForYouContent ? (
                        (() => {
                          const words = right_for_you.heading.trim().split(' ');
                          const gradientPart = words.slice(-3).join(' ');
                          const normalPart = words.slice(0, -3).join(' ');
                          return (
                            <>
                              {normalPart}{' '}
                              <span className='gradientText'>
                                {gradientPart}
                              </span>
                            </>
                          );
                        })()
                      ) : (
                        <>
                          Is {title}{' '}
                          <span className='gradientText'>Right For You?</span>
                        </>
                      )}
                    </h2>
                    <div className='tw-w-full tw-flex tw-flex-col tw-gap-y-4'>
                      <p className='tw-m-0 tw-text-[#5F5F5F] tw-text-sm lg:tw-text-base'>
                        {hasRightForYouContent
                          ? right_for_you.intro
                          : 'Many people seek treatment when they notice:'}
                      </p>
                      <ul className='tw-p-0 tw-list-none'>
                        {(hasRightForYouContent
                          ? extractListItems(right_for_you.items)
                          : symptomsList
                        )?.map((symptom, index) => (
                          <li
                            key={index}
                            style={{
                              borderBottom: '0.5px solid rgba(0,0,0,.125)',
                            }}
                            className='tw-py-3 tw-flex tw-items-center tw-gap-x-2 tw-text-sm'
                          >
                            <span className='tw-m-0 tw-text-[#5F5F5F] tw-text-sm '>
                              {symptom}
                            </span>
                          </li>
                        ))}
                      </ul>
                      <p className='tw-m-0 tw-text-[#5F5F5F] tw-text-sm lg:tw-text-sm'>
                        {hasRightForYouContent
                          ? right_for_you.footer_note
                          : 'Not all symptoms need to be present. A short assessment helps determine if treatment is appropriate.'}
                      </p>
                      <button className='refill-cta tw-border-none tw-w-full lg:tw-w-max tw-mt-4 '>
                        <Link href={`${path}`}>
                          <div
                            onClick={reportCta}
                            className='tw-w-full tw-bg-black tw-text-white tw-flex tw-items-center tw-gap-x-2 tw-justify-center tw-px-4 tw-py-3 tw-rounded-full tw-font-medium tw-text-base'
                          >
                             Get treatment online
                            <ArrowRightShort />
                          </div>
                        </Link>
                      </button>
                    </div>
                  </div>
                </Col>
                <Col
                  lg={{ span: 6, offset: 1 }}
                  className='tw-relative tw-mt-6 lg:tw-mt-0 px-lg-0'
                >
                  <div className='position-relative tw-w-full tw-min-h-[343px] lg:tw-min-h-[700px] tw-rounded-2xl tw-overflow-hidden'>
                    <Image
                      src={image2}
                      alt={title}
                      layout='fill'
                      //objectFit='cover'
                      className='tw-rounded-2xl tw-object-cover'
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </section>
      )}
      {isWeightloss ? (
        <section className='tw-w-full tw-py-8 lg:tw-py-12 page-container'>
          <TrustBoxWide />
        </section>
      ) : null}
      {weightLossMeds.some((med) => med.id === objectID) && (
        <section className='tw-w-full tw-py-8 lg:tw-py-12'>
          <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem]'>
            <Container fluid className='px-0'>
              <Row>
                <Col xs={12} lg={{ span: 4 }}>
                  <div
                    // style={{
                    //   border:
                    //     selectedMed?.name.toLowerCase() === 'semaglutide'
                    //       ? 'border-gradient'
                    //       : '1px solid #E0E0E0',
                    // }}
                    className={`tw-rounded-3xl ${
                      selectedMed?.name.toLowerCase() === 'semaglutide'
                        ? 'border-gradient'
                        : 'border-simple'
                    }`}
                  >
                    <div className='tw-px-5 tw-py-8 lg:tw-py-6 tw-rounded-3xl tw-bg-white tw-w-full tw-flex tw-flex-col'>
                      <h3 className='tw-m-0 tw-font-semibold tw-text-xl lg:tw-text-2xl tw-text-[#0F0F0F] tw-mb-4'>
                        {selectedMed?.name}
                      </h3>
                      <div className='tw-flex tw-items-center tw-gap-2 tw-bg-[#EAF4F7] tw-px-3 tw-py-[6px] tw-rounded-full tw-w-fit tw-mb-6'>
                        <div className='tw-w-[7px] tw-h-[7px] tw-rounded-full tw-bg-doc_blue'></div>
                        <span className='tw-text-xs tw-uppercase tw-tracking-[0.24px] tw-m-0'>
                          {selectedMed?.badgeText}
                        </span>
                      </div>
                      <div className='tw-flex tw-flex-col tw-gap-y-2 tw-mb-6'>
                        <div className='tw-flex tw-items-center tw-gap-2 tw-flex-wrap'>
                          <div className='tw-flex tw-items-center tw-gap-x-[9px]'>
                            <span className='tw-font-semibold tw-text-[30px] tw-text-[#1E1E1E] tw-tracking-[-1.2px]'>
                              ${selectedMed?.priceDiscounted}
                            </span>
                            <span className='tw-line-through tw-text-[#C1C1C1] tw-text-xl tw-tracking-[-0.8px]'>
                              $
                              {selectedMed &&
                                Math.round(
                                  selectedMed.priceDiscounted /
                                    (1 - WEIGHT_LOSS_DISCOUNT_PERCENT / 100)
                                )}
                            </span>
                          </div>
                          <span className='tw-text-xs tw-text-[#1E1E1E]'>
                            /month
                          </span>
                        </div>
                        <div className='tw-bg-[#195D9D] tw-rounded-full tw-px-5 tw-py-.5 tw-w-fit'>
                          <span className='tw-text-white tw-text-[13px] tw-font-semibold tw-whitespace-nowrap'>
                            {WEIGHT_LOSS_DISCOUNT_PERCENT}% off first order
                          </span>
                        </div>
                      </div>
                      <div className='tw-w-full tw-h-[0.5px] tw-bg-[#195D9D] tw-mb-4'></div>
                      <p className='tw-m-0 tw-text-xs tw-text-[#606060] tw-opacity-70'>
                        {selectedMed?.description}
                      </p>
                      <div className='tw-relative tw-w-[317px] tw-h-[335px] lg:tw-w-[330px] lg:tw-h-[370px] 2xl:tw-w-[400px] blue-gradient-bg md:tw-place-self-end lg:tw-place-self-center'>
                        <Image
                          src={selectedMed?.img}
                          alt={selectedMed?.name}
                          layout='fill'
                          object-fit='cover'
                        />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col
                  //xs={12}
                  xs={{ span: 12, order: 'first' }}
                  lg={{ span: 7, offset: 1, order: 'last' }}
                  className='tw-mb-6 lg:tw-mb-0'
                >
                  <div className='tw-flex tw-flex-col tw-justify-center tw-h-full'>
                    <h2 className='tw-font-semibold tw-text-[2rem] lg:tw-text-[44px] tw-mb-10'>
                      {selectedMed?.title}
                    </h2>
                    <div className='tw-flex tw-flex-col'>
                      <p className='tw-mb-6 tw-text-[#5F5F5F]'>
                        Why thousands choose 24hrDoc for weight loss
                      </p>
                      <ul className='tw-list-none tw-pl-0 tw-mb-6'>
                        {getDocBenefits(objectID).map((item, index) => (
                          <li
                            style={{
                              borderBottom:
                                '0.5px solid rgba(30, 30, 30, 0.32)',
                            }}
                            key={index}
                            className='tw-text-sm tw-text-[#5F5F5F] tw-mb-2 tw-py-3 tw-flex tw-items-center tw-gap-2'
                          >
                            <div className='tw-flex-shrink-0'>
                              {' '}
                              <ArrowBlue />
                            </div>

                            {item}
                          </li>
                        ))}
                      </ul>
                      <div className='tw-w-full lg:tw-w-fit'>
                        <button
                          className='tw-w-full lg:tw-w-fit tw-border-none hero-home-new-cta tw-mb-2'
                          onClick={reportCta}
                        >
                          <div className='tw-w-full tw-bg-black tw-text-white tw-px-6 tw-py-3 tw-rounded-full tw-space-x-2'>
                            <span> Start Medical Assessment</span>

                            <ArrowRightShort />
                          </div>
                        </button>
                        <p className='tw-text-xs tw-text-center lg:tw-text-left'>
                          {' '}
                          * Receive{' '}
                          <span className='gradientText tw-font-bold'>
                            15%{' '}
                          </span>
                          off for the first month
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </section>
      )}
      {showNav ? (
        <div className={`theNavBar`}>
          <div className='theInnerNavBar'>
            {sections?.map((item, index) => (
              <a
                key={index}
                href={`#${index + 2}`}
                onClick={() => setActiveSection(index)}
              >
                <span
                  className={`${
                    index === activeSection ? 'activeSection' : 'section'
                  }`}
                >
                  {index + 1}.&nbsp; {item.title}
                </span>
              </a>
            ))}
          </div>
        </div>
      ) : (
        <br />
      )}
    </>
  );
};

export default Hero;
// const sections = [
//   { id: 1, label: `Overview`, section: '#overview' },
//   { id: 2, label: `How it spreads`, section: '#spread' },
//   { id: 3, label: `Prevention`, section: '#prevention' },
//   { id: 4, label: `Signs & symptoms`, section: '#symptoms' },
//   { id: 5, label: `Treatments`, section: '#treatment' },
//   { id: 6, label: `FAQ`, section: '#faqs' },
// ];
const steps = [
  {
    id: 1,
    img: weightLossStep1,
    title: `Tell Us About Your Symptoms`,
    body: (
      <div className='tw-flex tw-flex-col tw-gap-y-2'>
        <p className='tw-m-0 tw-text-sm tw-text-[#5F5F5F] tw-text-center lg:tw-text-left'>
          Answer a short medical questionnaire so we can understand your
          condition and determine if treatment is appropriate.
        </p>
        <ul className='tw-text-sm tw-text-[#5F5F5F] tw-text-center tw-list-inside lg:tw-text-left lg:tw-list-outside'>
          <li>No in-person visit required</li>
          <li>No insurance required</li>
          <li>Transparent pricing before checkout</li>
        </ul>
      </div>
    ),
  },
  {
    id: 2,
    img: weightLossStep2,
    title: `Reviewed by a Licensed Provider`,
    body: (
      <div className='tw-flex tw-flex-col tw-gap-y-2'>
        <p className='tw-m-0 tw-text-sm tw-text-[#5F5F5F] tw-text-center lg:tw-text-left'>
          A licensed medical provider reviews your information to ensure the
          treatment is safe and appropriate.
        </p>
        <ul className=' tw-text-sm tw-text-[#5F5F5F] tw-text-center tw-list-inside lg:tw-text-left lg:tw-list-outside'>
          <li>Real medical review</li>
          <li>Safe, personalized decision</li>
          <li>No commitment</li>
        </ul>
      </div>
    ),
  },
  {
    id: 3,
    img: howStep3,
    title: `Prescription Sent to Pharmacy`,
    body: (
      <div className='tw-flex tw-flex-col tw-gap-y-2'>
        <p className='tw-m-0 tw-text-sm tw-text-[#5F5F5F] tw-text-center lg:tw-text-left'>
          If approved, your prescription is sent directly to your selected
          pharmacy for pickup.
        </p>
        <ul className='tw-text-sm tw-text-[#5F5F5F] tw-text-center tw-list-inside lg:tw-text-left lg:tw-list-outside'>
          <li>Fast processing (often same day)</li>
          <li>Secure electronic prescription</li>
          <li>Clear next steps after approval</li>
        </ul>
      </div>
    ),
  },
];
const weightLossSteps = [
  {
    id: 1,
    img: weightLossStep1,
    title: 'Complete a Quick Assessment',
    body: (
      <div className='tw-flex tw-flex-col tw-gap-y-2'>
        <p className='tw-m-0 tw-text-sm tw-text-[#5F5F5F] tw-text-center lg:tw-text-left'>
          Answer a short medical questionnaire so we can understand your weight
          loss goals, health history, and whether our program is the right fit
          for you.
        </p>
        <ul className='tw-text-sm tw-text-[#5F5F5F] tw-text-center tw-list-inside lg:tw-text-left lg:tw-list-outside'>
          <li>Takes about 10 minutes</li>
          <li>Simple, guided questions</li>
          <li>No commitment required</li>
        </ul>
      </div>
    ),
  },
  {
    id: 2,
    img: weightLossStep2,
    title: 'Get reviewed by a licensed provider',
    body: (
      <div className='tw-flex tw-flex-col tw-gap-y-2'>
        <p className='tw-m-0 tw-text-sm tw-text-[#5F5F5F] tw-text-center lg:tw-text-left'>
          A licensed provider reviews your information and creates a low-dose,
          medically guided weight loss protocol tailored to your body and goals.
        </p>
        <ul className='tw-text-sm tw-text-[#5F5F5F] tw-text-center tw-list-inside lg:tw-text-left lg:tw-list-outside'>
          <li>Reviewed by a qualified provider</li>
          <li>No insurance required</li>
          <li>Medical review before anything starts</li>
        </ul>
      </div>
    ),
  },
  {
    id: 3,
    img: howStep3,
    title: 'Prescription prepared & Delivered',
    body: (
      <div className='tw-flex tw-flex-col tw-gap-y-2'>
        <p className='tw-m-0 tw-text-sm tw-text-[#5F5F5F] tw-text-center lg:tw-text-left'>
          Once approved, your prescription is sent to the pharmacy and prepared
          for discreet pickup or delivery — so you can start your program
          without delay.
        </p>
        <ul className='tw-text-sm tw-text-[#5F5F5F] tw-text-center tw-list-inside lg:tw-text-left lg:tw-list-outside'>
          <li>Ongoing monitoring</li>
          <li>Ability to pause or adjust anytime</li>
          <li>Support throughout the process</li>
        </ul>
      </div>
    ),
  },
];

export const extractListItems = (html) => {
  const items = [];

  const getText = (nodes) =>
    (nodes || []).map((n) => (n.data ? n.data : getText(n.children))).join('');

  if (typeof html === 'string' && html.trim()) {
    parser(html, {
      replace: (domNode) => {
        if (domNode.name === 'li') {
          const text = getText(domNode.children).trim();
          if (text) items.push(text);
        }
      },
    });
  }

  return items;
};
const WEIGHT_LOSS_DISCOUNT_PERCENT = 15;

const weightLossMeds = [
  {
    numericId: 1,
    heading: (
      <>
        Semaglutide Prescription.
        <br className='tw-hidden XL:tw-block' />{' '}
        <span className='gradientText'>Provider guided.</span> Once a{' '}
        <br className='tw-hidden XL:tw-block' /> Week. Real Support.
      </>
    ),

    priceDiscounted: 135,
    name: 'Semaglutide',
    id: 'dDZLlErdEF',
    sameIngredientAs: 'Ozempic and Wegovy',
    badgeText: 'WEEKLY INJECTIONS',
    description:
      'A once-weekly GLP-1 receptor agonist injection used to treat type 2 diabetes and chronic weight management in adults who are overweight or obese.',
    offerNote: '* Receive $100 off for the first month',
    img: weightLossInjection,
    title: (
      <>
        <span className='gradientText'>Lose more weight</span>. Pay less than
        you <br className='tw-hidden 2xl:tw-block' />
        think.
      </>
    ),
  },
  {
    numericId: 2,
    heading: (
      <>
        Oral Semaglutide{' '}
        <span className='gradientText'>
          No
          <br className='tw-hidden XL:tw-block' /> Injections{' '}
        </span>
        . Real Support.
        <br className='tw-hidden XL:tw-block' /> Fully Online.
      </>
    ),
    priceDiscounted: 160,
    id: 'pmj8BBmv1L',
    name: 'Oral Semaglutide',
    sameIngredientAs: 'Ozempic and Wegovy',
    badgeText: 'DISSOLVABLE TABLETS OR DROPS',
    description:
      'A once-daily GLP-1 receptor agonist tablet taken before the first meal of the day to improve glycemic control in adults with type 2 diabetes.',
    offerNote: '* Receive $100 off for the first month',
    img: weightLossOral,
    title: (
      <>
        Clinically studied active ingredient — semaglutide —{' '}
        <span className='gradientText'>in oral form</span>.
      </>
    ),
  },
  {
    numericId: 3,
    heading: (
      <>
        Tirzepatide Prescription.
        <br className='tw-hidden XL:tw-block' /> Clinically studied.{' '}
        <span className='gradientText'>
          Once a <br className='tw-hidden XL:tw-block' /> Week{' '}
        </span>
        . Real Support.
      </>
    ),
    priceDiscounted: 211,
    id: 'o8NlDExkLo',
    name: 'Tirzepatide',
    sameIngredientAs: 'Mounjaro and Zepbound',
    badgeText: 'WEEKLY INJECTIONS',
    description:
      'A once-weekly GLP-1 receptor agonist injection used to treat type 2 diabetes and chronic weight management in adults who are overweight or obese.',
    offerNote: '* Receive $100 off for the first month',
    img: weightLossInjection,
    title: (
      <>
        <span className='gradientText'>Lose more weight</span>. Pay less than
        you <br className='tw-hidden lg:tw-block' />
        think.
      </>
    ),
  },
  // {
  //   numericId: 4,
  //   priceDiscounted: 239,
  //   priceOriginal: 339,
  //   id: 'CQ6HLzXB76',
  //   name: 'Oral Tirzepatide',
  //   sameIngredientAs: 'Mounjaro and Zepbound',
  //   badgeText: 'DISSOLVABLE TABLETS OR DROPS',
  //   description:
  //     'A once-daily GLP-1 receptor agonist tablet token before the first meal of the day, used to improve glycemic control in adults with type 2 diabetes.',
  //   offerNote: '* Receive $100 off for the first month',
  //   img: weightLossOral,
  //   title: (
  //     <>
  //       <span className='gradientText'>Lose more weight</span>. Pay less than
  //       you <br className='tw-hidden lg:tw-block' />
  //       think.
  //     </>
  //   ),
  // },
];
// Tirzepatide (id 'o8NlDExkLo') gets its own ingredient line instead of
// the semaglutide one every other weight-loss med shares.
function getDocBenefits(objectID) {
  return [
    'Board-certified providers – Every prescription reviewed and approved before it ships',
    objectID === 'o8NlDExkLo'
      ? 'Clinically studied active ingredient — tirzepatide, a dual GLP-1 and GIP receptor agonist used in FDA-approved weight management programs.'
      : 'Clinically studied active ingredient – semaglutide, used in the most prescribed GLP-1 programs',
    'Unlimited provider access – Message your care team anytime, no appointments needed',
    'Discreet shipping – Fast delivery with no extra fees and no visible branding',
  ];
}
